import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { sdk } from '@/services/sdk';
import { useFetch } from '@/hooks/useFetch';
import { PageHeader } from '@/components/kit';
import { BackLink, recordGate } from '@/components/record';
import ProductForm, { productToForm } from '@/components/admin/ProductForm';
import { PRODUCT_FIELDS } from '@/shared/fields';
import { committed } from '@/shared/data';

export const route = { path: '/admin/products/:id/edit', layout: 'owner', access: "['Admin_c','Staff_c'].includes(profile)" };

export default function EditProduct() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

  const { data: product, loading, error, run } = useFetch(
    () => sdk.table('products_c').select(PRODUCT_FIELDS).get(id).then((r) => r.data ?? null),
    [id],
  );

  const back = <BackLink to={`/admin/products/${id}`} label="Back to Product" />;
  const gate = recordGate({ back, loading, record: product, error, run, what: 'Product' });
  if (gate) return gate;

  async function save(payload) {
    setSaving(true);
    try {
      const res = await sdk.table('products_c').update({ Id: product.Id, ...payload });
      if (!committed(res, 'Product saved')) return;
      navigate(`/admin/products/${product.Id}`);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="mx-auto max-w-5xl">
      {back}
      <PageHeader eyebrow="Edit product" title={product.Name} />
      <ProductForm
        key={product.Id}
        initial={productToForm(product)}
        recordId={product.Id}
        onSubmit={save}
        saving={saving}
        submitLabel="Save changes"
        cancelTo={`/admin/products/${product.Id}`}
      />
    </div>
  );
}
